import React, { useEffect, useState } from "react";
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router";
import BoxLayout from "../../../components/Common/BoxLayout/BoxLayout";
import { createNewEvent } from "../../../utils/mainTabs/events/createNewEvent";
import { getAllVariantLanguagesActionHandler } from "../../../store/actions/actionHandlers/manageActionHandler";
import { useDispatch, useSelector } from "react-redux";
import { getClassDetailsByIdActionHandler } from "../../../store/actions/actionHandlers/manageActionHandler";
import { useParams } from "react-router";
import { getClassDetailsByIdAction } from "../../../store/actions/actionCreators/manageActionCreator";
import { getTrainingTypesActionHandler } from "../../../store/actions/actionHandlers/manageActionHandler";

const CreateNewEvent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const { tiles: createNewEventTiles } = createNewEvent;
  const [allLanguageVariant, setAllLanguageVariant] = useState([]);
  const manageState = useSelector((state) => state.manageReducer);
  const { getClassDetailsById } = manageState;
  const {
    eventTiles,
    setEventTiles,
    setEventButtons,
    tenantName,
    eventPath,
    createNewEventPath,
    createNewEventEditPath,
    createNewEventCopyPath,
    createNewEventViewPath,
    roleTitle,
    isTenantProfileNameExist,
  } = useOutletContext();
  const [shotclassTypeFrom, setShotclassTypeFrom] = useState("");
  const [shotclassType, setShotclassType] = useState("create");
  const [trainingTypes, setTrainingTypes] = useState([]);
  let initialFormState = {
    details: {
      Language: "en-GB",
      Name: "",
      TrainingType: [],
      Tags: "",
    },
    addQuiz: {
      QuestionsList: [
        {
          Question: "",
          QuestionImage: [{}],
          ActiveQuestionType: 1,
          // IsCorrect: "0",
          IsCorrect: "",
          // MultiSelect: false,
          Explanation: "",
          Duration: 30,
          AnswersList: [
            { Answer: "", AnswerImage: "" },
            { Answer: "", AnswerImage: "" },
          ],
        },
      ],
      // Duration: "30",
      TotalQuestionCount: 0,
    },
  };
  const [formValues, setFormValues] = useState(initialFormState);
  const shotclassTypeFromLocal = localStorage.getItem("shotclassTypeFrom");
  useEffect(() => {
    let shotclassTypeFromVal = location?.state?.from || shotclassTypeFromLocal;
    if (shotclassTypeFromVal) {
      setShotclassTypeFrom(shotclassTypeFromVal);
    }
  }, [location, shotclassTypeFromLocal]);
  useEffect(() => {
    if (params?.shotclassId && shotclassTypeFrom) {
      let shotclassStatus =
        shotclassTypeFrom === "myDrafts" ? "Saved" : "Published";
      dispatch(
        getClassDetailsByIdActionHandler(params?.shotclassId, shotclassStatus)
      );
    }
    return () => {
      if (params?.shotclassId && shotclassTypeFrom) {
        dispatch(getClassDetailsByIdAction({}));
      }
    };
  }, [dispatch, params?.shotclassId, shotclassTypeFrom]);
  useEffect(() => {
    if (location.pathname === createNewEventPath) {
      let tilesList = createNewEventTiles(
        navigate,
        location,
        params,
        tenantName
      );
      setEventTiles(tilesList);
      navigate(`${location.pathname}/details`);
    } else if (
      location.pathname.includes(createNewEventPath) &&
      eventTiles?.length === 0
    ) {
      navigate(createNewEventPath);
    }
  }, [
    location,
    tenantName,
    createNewEventPath,
    params,
    dispatch,
    navigate,
    createNewEventTiles,
    eventTiles?.length,
    setEventTiles,
  ]);
  useEffect(() => {
    // if (trainingTypes?.length === 0) {
    dispatch(
      getTrainingTypesActionHandler(
        "",
        "",
        "",
        setTrainingTypes,
        () => {},
        () => {}
      )
    );
    // }
  }, [
    dispatch,
    //trainingTypes
  ]);
  useEffect(() => {
    if (allLanguageVariant?.length === 0) {
      dispatch(getAllVariantLanguagesActionHandler(setAllLanguageVariant));
    }
  }, [dispatch, allLanguageVariant]);
  useEffect(() => {
    if (
      !formValues.details.Name &&
      getClassDetailsById?.ID &&
      // trainingTypes?.length > 0 &&
      (location.pathname.includes(createNewEventEditPath) ||
        location.pathname.includes(createNewEventCopyPath) ||
        location.pathname.includes(createNewEventViewPath))
    ) {
      if (location.pathname.includes(createNewEventEditPath)) {
        setShotclassType("edit");
      } else if (location.pathname.includes(createNewEventCopyPath)) {
        setShotclassType("copy");
      } else if (location.pathname.includes(createNewEventViewPath)) {
        setShotclassType("view");
      }
      if (trainingTypes?.length > 0) {
        setFormValues((data) => {
          return {
            ...data,
            Other: { ...getClassDetailsById },
            shotclassId: getClassDetailsById?.ID,
            details: {
              ...data.details,
              Language: getClassDetailsById?.Locale || "en-GB",
              // TrainingType: getClassDetailsById?.TrainingTypeId?.[0]?.toString(),
              TrainingType: [
                {
                  TypeId: getClassDetailsById?.TrainingTypeId?.[0],
                  Name: trainingTypes.find(
                    (trainingType) =>
                      trainingType.TypeId ===
                      getClassDetailsById?.TrainingTypeId?.[0]
                  )?.Name,
                },
              ],
              Name: location.pathname.includes(createNewEventCopyPath)
                ? getClassDetailsById?.Name + "_Copy"
                : getClassDetailsById?.Name,
              Tags: getClassDetailsById?.Tags,
            },
            addQuiz: {
              QuestionsList:
                getClassDetailsById?.AssessmentSet?.QuestionList?.length > 0
                  ? getClassDetailsById?.AssessmentSet?.QuestionList?.map(
                      (question, qIndex) => {
                        return {
                          ...question,
                          ...getClassDetailsById?.AssessmentSet?.QuestionList?.[
                            qIndex
                          ],
                          Question: question?.Text,
                          QuestionImage: question?.QuestionImageList,
                          Explanation: question?.Explaination,
                          ActiveQuestionType: question?.Type,
                          IsCorrect: question?.ChoiceList?.reduce(
                            (result, item, index) => {
                              if (item?.IsAnswer) {
                                if (question?.Type === 1) {
                                  return index;
                                }
                                return item?.Text;
                              } else {
                                return result;
                              }
                            },
                            [0]
                          ).toString(),
                          AnswersList: question?.ChoiceList?.map(
                            (answer, aIndex) => {
                              return {
                                ...answer,
                                ...getClassDetailsById?.AssessmentSet
                                  ?.QuestionList?.[qIndex]?.ChoiceList?.[
                                  aIndex
                                ],
                                Answer: answer?.Text,
                                AnswerImage: answer?.ChoiceImageList || "",
                              };
                            }
                          ),
                        };
                      }
                    )
                  : [
                      {
                        Question: "",
                        QuestionImage: [{}],
                        ActiveQuestionType: 1,
                        IsCorrect: "",
                        MultiSelect: false,
                        Explanation: "",
                        Duration: 30,
                        AnswersList: [
                          { Answer: "", AnswerImage: "" },
                          { Answer: "", AnswerImage: "" },
                        ],
                      },
                    ],
              TotalQuestionCount:
                getClassDetailsById?.AssessmentSet?.QuestionList?.length || 0,
            },
          };
        });
      }
    }
  }, [
    tenantName,
    trainingTypes,
    location.pathname,
    getClassDetailsById,
    formValues.details.Name,
    createNewEventCopyPath,
    createNewEventEditPath,
    createNewEventViewPath,
    params,
  ]);
  // console.log("trainingTypes from common", trainingTypes);
  return (
    <BoxLayout margin={[0, 0, 0, 0]}>
      <Outlet
        context={{
          eventTiles,
          setEventTiles,
          allLanguageVariant,
          formValues,
          setFormValues,
          initialFormState,
          trainingTypes,
          setTrainingTypes,
          shotclassTypeFrom,
          shotclassType,
          tenantName,
          eventPath,
          createNewEventPath,
          createNewEventEditPath,
          roleTitle,
          isTenantProfileNameExist,
        }}
      />
      {/* <Outlet  context={{ eventTiles, setEventTiles }}/> */}
    </BoxLayout>
  );
};

export default CreateNewEvent;
